import { render } from "./RouteDraw.vue?vue&type=template&id=67ad1288"
import script from "./RouteDraw.vue?vue&type=script&lang=js"
export * from "./RouteDraw.vue?vue&type=script&lang=js"
script.render = render

export default script